import { call, put, takeLatest } from 'redux-saga/effects'

import { NOTIFICATION_TYPE } from '~/common/constants'
import addNotification from '~/utils/toast'

import {
  actGetReportBr11SummaryFailed,
  actGetReportBr11SummarySuccess,
  MASTER_GET_REPORT_BR11_SUMMARY,
} from '../../actions/report-br11'
import {
  apiGetReportBr11Summary,
} from '../../apis/report-br11'

/**
 * Handle get data request and response
 * @param {object} action
 */
function* doGetListSummary(action) {
  try {
    const response = yield call(apiGetReportBr11Summary, action?.payload)

    if (response?.statusCode === 200) {
      const data = {
        data: response.data.items,
        total: response.data?.meta?.total,
      }
      yield put(actGetReportBr11SummarySuccess(data))
      // Call callback action if provided
      if (action.onSuccess) {
        yield action.onSuccess()
      }
    } else {
      addNotification(response?.message, NOTIFICATION_TYPE.ERROR)
      throw new Error(response?.message)
    }
  } catch (error) {
    yield put(actGetReportBr11SummaryFailed())
    // Call callback action if provided
    if (action.onError) {
      yield action.onError(error)
    }
  }
}

export default function* watchGetListSummary() {
  yield takeLatest(MASTER_GET_REPORT_BR11_SUMMARY, doGetListSummary)
}
